function getDictLabel(list,id){
    let label
    for (let i = 0; i < list.length; i++) {
        const element = list[i];
        if(id == element.dictValue){
            label = element.dictLabel
        }
    }
    return label;
}
function baseURL(){
    return 'http://admin.cimomicro.com/prod-api'
}
function backPage(page){
    if(page == '-1'){
        this.$router.go(-1)
    }else{
        this.$router.push(page)
    }
}
// function isValidUrl(s) {
//     console.log(s);
//     let pattern = new RegExp('^(https?:\\/\\/)?'+ // protocol
//     '((([a-z\\d]([a-z\\d-]*[a-z\\d])*\\.)+[a-z]{2,}|'+ // domain name
//     '((\\d{1,3}\\.){3}\\d{1,3}))'+ // OR ip (v4) address
//     '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*'+ // port and path
//     '(\\?[;&a-z\\d%_.~+=-]*)?'+ // query string
//     '(\\#[-a-z\\d_]*)?$','i'); // fragment locator
//     return !!pattern.test(s);
// }
function isValidUrl(string){
    console.log(string);
    try {
      new URL(string);
      return true;
    } catch (err) {
      return false;
    }
  }
  
  function findNodePath(tree, targetId) {
    console.log(tree,targetId);
    // 递归查找函数
    function traverse(nodes, path) {
      for (const node of nodes) {
        // 当前路径
        const currentPath = [...path, node];
        
        // 找到目标节点
        if (node.id === targetId) {
          return currentPath;
        }
        
        // 如果有子节点，递归查找
        if (node.childrens && node.childrens.length) {
          const found = traverse(node.childrens, currentPath);
          if (found) return found;
        }
      }
      return null;
    }
    
    return traverse(tree, []) || [];
  }
export {getDictLabel,backPage,isValidUrl,findNodePath}


// WEBPACK FOOTER //
// ./src/utils/common.js